/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:bddb8488-0193-4e72-a528-2173d74fe5db",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_8MWdQQb1B",
    "aws_user_pools_web_client_id": "42d7f85urlod0kevu41sq5rem8",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "plus-tools-client-uploaddec7d-dev",
    "aws_user_files_s3_bucket_region": "us-east-2",
    "aws_content_delivery_bucket": "plus-tools-client-upload-static-site-dev",
    "aws_content_delivery_bucket_region": "us-east-2",
    "aws_content_delivery_url": "https://d31hkeawrujrv2.cloudfront.net"
};


export default awsmobile;
